// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"4af24085","787":"be34f68e","971":"fd2da82c"}[chunkId] + ".chunk.css";
};